<template>
  <div class="communication-channels-message-panel-wrapper">
    <div class="communication-channels-message-panel">
      <div class="communication-channels-message-panel-operator-info">
        <div class="communication-channels-message-panel-operator-info__icon">
          <img
            alt="Фото"
            :src="channelOperator.photoUrl || DefaultPhoto"
            class="communication-channels-message-panel-operator-info__icon-img"
          />
        </div>

        <div class="communication-channels-message-panel-operator-info__info">
          <div class="communication-channels-message-panel-operator-info__name">
            {{ channelOperator.title }}
          </div>
          <div class="communication-channels-message-panel-operator-info__time">
            {{ currentTime }}
          </div>
        </div>
      </div>

      <div
        class="communication-channels-message-panel__message"
        v-html="channelOperator.welcomeMessage"
      />

      <div
        class="communication-channels-message-panel__close"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script lang="ts">
import type { Types as CommunicationChannelOperatorTypes } from '@/entities/communication-channel-operator';

import DefaultPhoto from './images/defaultPhoto.png';

export default defineComponent({
  name: 'OperatorCard',

  props: {
    channelOperator: {
      type: Object as PropType<CommunicationChannelOperatorTypes.ICommunicationChannelOperator>,
      default: () => ({}),
    },
  },

  emits: ['close'],

  setup() {
    return {
      DefaultPhoto,
    };
  },

  data(): {
    timer: ReturnType<typeof setTimeout> | null;
    currentTime: string;
  } {
    return {
      timer: null,
      currentTime: '',
    };
  },

  created() {
    this.timer = setInterval(this.getCurrentTime, 1000 * 60);
    this.getCurrentTime();
  },

  unmounted() {
    if (!this.timer) {
      return;
    }

    clearInterval(this.timer);
  },

  methods: {
    getCurrentTime() {
      const date = new Date();

      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      this.currentTime = `${hours}:${minutes}`;
    },
  },
});
</script>

<style lang="scss" scoped>
.communication-channels-message-panel-wrapper {
  width: 259px;

  &:before {
    content: '';
    height: 1px;
    width: 1px;
    box-shadow: 2px 2px 10px 7px rgba(0, 0, 0, 0.2);
    position: absolute;
    right: -1px;
    bottom: 30px;
    z-index: 1;
  }

  .communication-channels-message-panel {
    z-index: 2;
    position: relative;
  }

  &:after {
    content: '';
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 0 12px 17px 0px;
    border-color: transparent transparent #fff transparent;
    transform: rotate(0deg);
    position: absolute;
    right: -12px;
    bottom: 25px;
    z-index: 2;
  }
}

.communication-channels-message-panel {
  background-color: #fff;
  padding: 39px 20px 20px 37px;
  box-sizing: border-box;
  box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.2);
  width: 100%;
  height: 100%;

  &__close {
    width: 18px;
    height: 18px;
    background-image: url('./images/close.svg');
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }

  &__message {
    font-family: 'Roboto-Light', sans-serif;
    font-size: 16px;
    letter-spacing: 0.85px;
    line-height: 19.5px;
  }

  .communication-channels-message-panel-operator-info {
    display: flex;
    gap: 18px;
    margin-bottom: 15px;

    &__icon {
      height: 40px;
      width: 40px;

      img {
        height: 100%;
        width: 100%;
      }
    }

    &__name {
      font-family: 'Gilroy-Regular', sans-serif;
      font-size: 16px;
      letter-spacing: 0.7px;
      padding-top: 4px;
      margin-bottom: 3px;
    }

    &__time {
      font-family: 'Roboto-Light', sans-serif;
      font-size: 15px;
      letter-spacing: 1px;
      color: #888691;
      margin-top: -3px;
    }
  }
}
</style>
